import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
  DialogActions
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import Spinner from 'modules/common/spinner.component';

const InternalMultiClientUsersGrid = ({ users, isLoading, onAccessChange, onDeleteUser }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Actions</TableCell>
            <TableCell>Full Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell align="center">Access</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {!isLoading && users.length === 0 && (
            <TableRow>
              <TableCell colSpan={2} align="center">
                <Typography color="textSecondary">No multi-client users have been configured.</Typography>
              </TableCell>
            </TableRow>
          )}
          {isLoading && (
            <DialogActions sx={{ p: '1.25rem' }}>
              <Spinner />
            </DialogActions>
          )}
          {!isLoading &&
            users.map(user => (
              <TableRow key={user.internalMultiClientUserId}>
                <TableCell align="center">
                  <Tooltip arrow placement="right" title="Delete">
                    <IconButton color="error" onClick={() => onDeleteUser(user)}>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell>{user.fullName || '-'}</TableCell>
                <TableCell>{user.auth0EmailAddress || user.auth0UserId}</TableCell>
                <TableCell align="center">
                  <Switch
                    color="primary"
                    checked={!user.hasAccessRevoked}
                    onChange={() => onAccessChange(user)}
                    inputProps={{
                      'aria-label': `Toggle access for ${user.auth0EmailAddress || user.auth0UserId}`
                    }}
                  />
                  <Typography variant="caption" color={user.hasAccessRevoked ? 'error' : 'primary'}>
                    {user.hasAccessRevoked ? 'Revoked' : 'Active'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

InternalMultiClientUsersGrid.defaultProps = {
  users: [],
  isLoading: false
};

InternalMultiClientUsersGrid.propTypes = {
  users: PropTypes.array,
  isLoading: PropTypes.bool,
  onAccessChange: PropTypes.func.isRequired,
  onDeleteUser: PropTypes.func.isRequired
};

export default InternalMultiClientUsersGrid;
